$(document).ready(function(){

	var cvs = document.querySelector(".editor-wrapper #canvas");
	var ctx = cvs.getContext("2d");
	var aspectRation = 603 / 355; 
	cvs.width = cvsW = 603; 
	// cvs.width = cvsW = cvs.scrollWidth; 
	cvs.height = cvsH = cvsW / aspectRation;

	var designoptions = {
		coloursBackground : "#ff99ff",
		coloursBackgroundName : "Pink",
		coloursText : "#ffff00",
		coloursTextName : "Yellow",
		fonts : "Arial",
		keyboardEnglish : [],
		keyboardSymbols : [],
		keyboardSymbolsImg : {},
		keyboardText : []
	}

	$("button[data-workspace-control]").click(function(){
		$current_workspace = $(this).attr("data-workspace-control");
		if($current_workspace == "reset"){
			return false;
		}
		$(".blanket-symbols-group-selector").hide();
		$("button[data-workspace-control]").removeClass("is-active");
		$(this).addClass("is-active");

		$(".workspaces").removeClass("active-workspaces");
		$("#"+$current_workspace).addClass("active-workspaces");
		if($current_workspace == "keyboard--symbols"){
			$(".blanket-symbols-group-selector").show();
		}

	});

	// background color
	$("#colours--background .swatch").click(function(){
		$("#colours--background .swatch").removeClass("is-active");
		$(this).addClass("is-active");
		designoptions['coloursBackground'] = $(this).attr("data-swatch-hex");
		designoptions['coloursBackgroundName'] = $(this).attr("data-swatch");
		$('.toolbar-control--swatch[data-workspace-control="colours--background"]').css("backgroundColor",designoptions['coloursBackground']);
		drawblanket();
	});

	// text color
	$("#colours--text .swatch").click(function(){
		$("#colours--text .swatch").removeClass("is-active");
		$(this).addClass("is-active");
		designoptions['coloursText'] = $(this).attr("data-swatch-hex");
		designoptions['coloursTextName'] = $(this).attr("data-swatch");
		$('.toolbar-control--swatch[data-workspace-control="colours--text"]').css("backgroundColor",designoptions['coloursText']);
		drawblanket();
	});

	// fonts
	$("#fonts button").click(function(){
		$("#fonts button").removeClass("is-active");
		$(this).addClass("is-active");
		designoptions['fonts'] = $(this).attr("data-font");
		drawblanket();
		drawblanket();
	});

	// letters keyboard
	$("#keyboard--english button, .keyboard__key--space , .keyboard__key--wide").click(function(){
		var currentkey = $(this).attr("data-key-character");
		if (typeof currentkey !== typeof undefined && currentkey !== false) {
		designoptions['keyboardEnglish'].push(currentkey);
		designoptions['keyboardText'].push(currentkey);
		drawblanket();
	   } else {
	   	var deletekey = $(this).attr("data-key-action");
		if (typeof deletekey !== typeof undefined && deletekey === "delete") {
		designoptions['keyboardText'].pop();
		drawblanket();
	   }
	  }
	});
	
  var symbolsloaded = {};
	// symbols
	$("#keyboard--symbols button").click(function(){
		var currentkey = $(this).attr("data-key-character");
		if (typeof currentkey !== typeof undefined && currentkey !== false) {
		var currentSrc = $(this).find("img").attr("src");	
		var tempimage = new Image();
         tempimage.crossOrigin = "Anonymous";
          //cdn.shopify.com/s/files/1/0091/1333/7918/t/1/assets/bat-canvas.png?678
          currentSrc = currentSrc.replace("//cdn", "https://cdn");
          currentSrc = currentSrc.split("?")[0];
//           console.log(symbolsloaded);
          if(currentkey in symbolsloaded){
//             console.log("includes");
			designoptions['keyboardSymbols'].push(currentkey);
			designoptions['keyboardText'].push(currentkey);
			designoptions["keyboardSymbolsImg"][currentkey] = symbolsloaded[currentkey];
			drawblanket();          
          
          } else {
//               console.log("not loaded");	
	          tempimage.src = currentSrc;
          }

        
		tempimage.onload = function(){
            symbolsloaded[currentkey]= tempimage;
			designoptions['keyboardSymbols'].push(currentkey);
			designoptions['keyboardText'].push(currentkey);
			designoptions["keyboardSymbolsImg"][currentkey] = tempimage;
			drawblanket();
		}
		tempimage.onerror = function(response){
          console.log(response);
			alert("Image not loaded");
		}

		drawblanket();
	    }
	});

	// switch keyboard
	$("#keyboard--english button[data-keyboard-section-control]").click(function(){
		var dataKeyboardSectionControl = $(this).attr("data-keyboard-section-control");
		$(".keyboard__section").hide(0);
		$('.keyboard__section[data-keyboard-section="'+dataKeyboardSectionControl+'"]').show(0);
	});

	// reset
	$(".blanket-toolbar__control--reset .toolbar-control--tab").click(function(){
		designoptions['keyboardEnglish'] = [];
		designoptions['keyboardText'] = [];
		drawblanket();
	});

	$(".completion-button").click(function(evt){
		evt.preventDefault();
		$(".completion-button").prop("disabled",true);
		$('.loader-image').show();
	// properties
	$('.blanket-builder__completion input[name="properties[_message]"]').val(designoptions['keyboardText'].join(", " ));
	$('.blanket-builder__completion input[name="properties[_font_family]"]').val(designoptions['fonts']);
	// $('.blanket-builder__completion input[name="properties[_message_letters]"]').val(designoptions['keyboardEnglish'].join(", "));
	// $('.blanket-builder__completion input[name="properties[_message_symbols]"]').val(designoptions['keyboardSymbols'].join(", "));
	$('.blanket-builder__completion input[name="properties[_text_colour]"]').val(designoptions['coloursTextName']);
	$('.blanket-builder__completion input[name="properties[_background_colour]"]').val(designoptions['coloursBackgroundName']);
	$('.blanket-builder__completion input[name="properties[_text_colour_hex]"]').val(designoptions['coloursText']);
	$('.blanket-builder__completion input[name="properties[_background_colour_hex]"]').val(designoptions['coloursBackground']);
	// properties

		var finalimgcvs = document.createElement("canvas");
		var finalimgctx = finalimgcvs.getContext("2d");
      	
      	var scalefatorfinal = cwidth / cvsW;
      
		finalimgcvs.width = cvsW * scalefatorfinal;
		finalimgcvs.height = cvsH * scalefatorfinal;
		finalimgctx.fillStyle = designoptions['coloursText'];
		finalimgctx.fillRect(0, 0, cvsW * scalefatorfinal, cvsH * scalefatorfinal);
		finalimgctx.drawImage(cvs, 0, 0, cvsW, cvsH, 0, 0, cvsW * scalefatorfinal, cvsH * scalefatorfinal);	

		var blanketdata = finalimgcvs.toDataURL('image/bmp', 1);
		var file = dataURItoBlob(blanketdata);
		var fd = new FormData();
		fd.append("customized-", file);
      
//       var node = document.querySelector('.editor-wrapper');
//       domtoimage.toPng(node)
//       .then(function (dataUrl) {
//       	alert(dataUrl);
//       });
      
        
    $.ajax({
       	url: "https://assets.dadda.ro/personalisation_app/uploadimg.php",
       // url: "https://appsworld.website/sapp/t1/staging/personalisation_app/uploadimg.php",
      // url: "https://shopify.wpfruits.com/staging/sandeep/personalisation_app/uploadimg.php", http://assets.dadda.ro/
        type: "POST",
        data: fd,
        processData: false,
        contentType: false,
        async: false,
    }).done(function(respond) {
    	console.log(respond);
      $('.blanket-builder__completion input[name="properties[customized_image]"]').val("https://assets.dadda.ro/personalisation_app/"+respond);
	//$('.blanket-builder__completion input[name="properties[customized_image]"]').val("https://appsworld.website/sapp/t1/staging/personalisation_app/"+respond);
      //		$('.blanket-builder__completion input[name="properties[customized_image]"]').val("https://shopify.wpfruits.com/staging/sandeep/personalisation_app/"+respond);
        $('.loader-image').hide();
//         $(".completion-button").prop("disabled",false);
      	$(".completion-form").submit();
    }).fail(function(){
    	alert("There is some error");
    });

	});

	drawblanket();

	function drawblanket(){
// 		console.log("designoptions");
// 		console.log(designoptions);

		ctx.clearRect(0,0,cvsW,cvsH);
		if(designoptions["keyboardText"].length){

			$(".editor-wrapper #canvas").css({"backgroundImage":"none","backgroundColor":designoptions["coloursText"]});

			ctx.globalCompositeOperation = "source-over";
			ctx.fillStyle = designoptions["coloursBackground"];
			ctx.fillRect(0,0,cvsW,cvsH);

			ctx.fillStyle = designoptions["coloursText"];
			ctx.font = "38px "+designoptions["fonts"];
			ctx.textAlign = "start"; 
			ctx.textBaseline = "middle"; 
			var startpointX = 0;
			var canvasdesignlength= 0;

			for(var layer = 0; layer < 7; layer++){

			var stratdecider = layer % 2;
			var startpointX = -(canvasdesignlength * stratdecider) / 2;
			var startpointY = (layer * 50.714285714) + 25.357142857;	

			while(startpointX < cvsW){
			designoptions["keyboardText"].forEach(function(currentValue, index, arr){
			if(designoptions["keyboardEnglish"].includes(currentValue)){
			ctx.globalCompositeOperation = "source-over";
			var currentwidth = ctx.measureText(currentValue).width
			ctx.fillText(currentValue, startpointX, startpointY);
			startpointX += currentwidth;
			} else if(designoptions["keyboardSymbols"].includes(currentValue)){
				ctx.globalCompositeOperation = "source-out";
				var currentImg = designoptions["keyboardSymbolsImg"][currentValue];
				var currentwidth = currentImg.width
				console.log(currentwidth);	
				ctx.save();
                ctx.translate(startpointX, startpointY);
                ctx.globalCompositeOperation = 'destination-out';
                ctx.drawImage(currentImg, 0, 0, currentImg.width, currentImg.height, 0, -currentImg.height / 2, currentImg.width, currentImg.height);
                ctx.restore();	

				startpointX += currentwidth;
			}
				
			});
			if(!canvasdesignlength){
				canvasdesignlength= startpointX;
			}
		  }
		 }
			$(".completion-button").prop("disabled",false);
			}
		else {
          $(".editor-wrapper #canvas").css({"backgroundImage":"url(https://cdn.shopify.com/s/files/1/0091/1333/7918/t/1/assets/default_canvas.png)","backgroundColor":"transparent"});
			$(".completion-button").prop("disabled",true);
		}

	}

	$(".options-values").scroll(function(){
		
		var scrolledDis = $(this).scrollTop();
		var optionsValuesTop = $(".options-values").offset().top
		$('.blanket-symbols-group-selector button[data-graphic-group]').removeClass("is-active");
		$("#keyboard--symbols .keyboard__group").each(function(){
		var keyboardGroupTop = $(this).offset().top;
		var keyboardGroupHeight = $(this).height();
		if(optionsValuesTop  <= (keyboardGroupTop + (keyboardGroupHeight / 2))){
			var currentGroup = $(this).attr("data-graphic-group");
			$('.blanket-symbols-group-selector button[data-graphic-group="'+currentGroup+'"]').addClass("is-active");
			return false;
		}
		});
	});

	$(".blanket-symbols-group-selector button[data-graphic-group]").click(function(){
		var currentGroup = $(this).attr("data-graphic-group");
		var scrolledDis = $(".options-values").scrollTop();
		var optionsValuesTop = $(".options-values").offset().top;
		var currentGroupTop = $('#keyboard--symbols .keyboard__group[data-graphic-group="'+currentGroup+'"]').offset().top;
		var reqdis = currentGroupTop - optionsValuesTop;

		$(".options-values").animate({
    	scrollTop: scrolledDis + reqdis }, 500);
		});

});

    function dataURItoBlob(dataURI) {
        var binary = atob(dataURI.split(',')[1]), array = [];
        for(var i = 0; i < binary.length; i++) array.push(binary.charCodeAt(i));
        return new Blob([new Uint8Array(array)], {type: 'image/bmp'});
    }